(function () {
    var codeBlocks = document.querySelectorAll('.article-content pre');

    if (!codeBlocks.length) {
        return;
    }

    var COPY_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"></rect><path d="M5 15V5a2 2 0 0 1 2-2h8"></path></svg>';
    var DONE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6.5"></path></svg>';

    var LANGUAGE_NAMES = {
        apex: 'Apex',
        sql: 'SQL',
        java: 'Java',
        javascript: 'JavaScript',
        js: 'JavaScript',
        typescript: 'TypeScript',
        ts: 'TypeScript',
        json: 'JSON',
        yaml: 'YAML',
        yml: 'YAML',
        bash: 'Shell',
        shell: 'Shell',
        markup: 'HTML',
        html: 'HTML',
        xml: 'XML',
        css: 'CSS',
        python: 'Python',
        diff: 'Diff',
        http: 'HTTP',
        markdown: 'Markdown',
        properties: 'Properties',
        csv: 'CSV'
    };

    function sourceText(block) {
        var code = block.querySelector('code');
        return (code ? code.textContent : block.textContent).replace(/\n+$/, '');
    }

    function languageLabel(block) {
        var code = block.querySelector('code');
        var match = code && code.className.match(/language-([\w-]+)/);
        var key = match ? match[1].toLowerCase() : '';

        return LANGUAGE_NAMES[key] || (key ? key.toUpperCase() : 'Code');
    }

    function buildCopyButton(block) {
        var button = document.createElement('button');

        button.type = 'button';
        button.className = 'code-copy';
        button.innerHTML = COPY_ICON + '<span>Copy</span>';
        button.setAttribute('aria-label', 'Copy code to clipboard');

        var resetTimer;

        button.addEventListener('click', function () {
            var write = navigator.clipboard
                ? navigator.clipboard.writeText(sourceText(block))
                : Promise.reject();

            write.then(function () {
                button.classList.add('is-copied');
                button.innerHTML = DONE_ICON + '<span>Copied</span>';
                button.setAttribute('aria-label', 'Code copied to clipboard');

                clearTimeout(resetTimer);
                resetTimer = setTimeout(function () {
                    button.classList.remove('is-copied');
                    button.innerHTML = COPY_ICON + '<span>Copy</span>';
                    button.setAttribute('aria-label', 'Copy code to clipboard');
                }, 2000);
            }).catch(function () {
                button.innerHTML = COPY_ICON + '<span>Press Ctrl+C</span>';
            });
        });

        return button;
    }

    Array.prototype.forEach.call(codeBlocks, function (block) {
        var shell = document.createElement('div');
        var bar = document.createElement('div');
        var label = document.createElement('span');

        shell.className = 'code-block';
        bar.className = 'code-block__bar';
        label.className = 'code-block__language';
        label.textContent = languageLabel(block);

        bar.appendChild(label);
        bar.appendChild(buildCopyButton(block));

        block.parentNode.insertBefore(shell, block);
        shell.appendChild(bar);
        shell.appendChild(block);
    });
})();
